import React from "react"
import LaunchScreen from "./LaunchScreen";
import WelcomPage from "./WelcomPage";
import MainContentView from "./MainContentView.jsx";
import { get, postFormData } from "../network/request"
import { grantBuns, getBunsBalance } from "../network/bunsApi";
import BunsRewardPopup from "../component/BunsRewardPopup";

import SelectType from "./SelectType";
import WorkType from "./WorkType";
import QuestionPage from "./QuestionPage";

// import {TONConnectPage} from "./TONConnectPage/TONConnectPage";

class MainPage extends React.Component{
    constructor(props){
        super(props)

        // localStorage.clear(); // 清除本地存储
        // localStorage.removeItem("firstRegisterDate"); // 初始化 BUNS 余额
        // localStorage.removeItem("lastDailyLogin");

        this.state = {
            showControl : 1,
            backColor: "#0B0D14",
            rewardPopup: { show: false, amount: 0, type: '', detail: '', newBalance: 0 },
        };

        // 绑定事件处理函数到当前实例  
        this.handleClick = this.handleClick.bind(this);
        this.handTypeClick = this.handTypeClick.bind(this)

        this.handQuestionClick = this.handQuestionClick.bind(this)
        this.handSelectQuestionClick = this.handSelectQuestionClick.bind(this)
    }

    componentDidMount() {
        this.timerId = setTimeout(() => {
            this.initCurrentMainPage();
        }, 800);
    }

    initCurrentMainPage() {
        let initUser = localStorage.getItem("initUser");

        if (initUser == null || initUser === "undefined" || initUser === "") { // 如果没有初始化用户
            this.setState({ showControl: 2 });
        } else {
            // 已经初始化用户
            let userJson = JSON.parse(initUser);
            localStorage.setItem("initUser", JSON.stringify(userJson));
            let selectJobType = userJson["jobType"];
            // 已经选择职业类型
            if (selectJobType === 1 || selectJobType === 2) {
                // 已经选择职业类型
                let jobsIds = userJson["job_ids"];
                if (jobsIds && jobsIds.length > 0) {

                    let jobQuestionType = userJson["jobQuestionType"];
                    if (!jobQuestionType || jobQuestionType === "undefined") {
                        this.setState({ showControl: 5 });
                    }else{
                        this.setState({ showControl: 6 });
                    }
                } else {
                    this.setState({ showControl: 4 });
                }
            } else {
                // 未选择职业类型
                this.setState({ showControl: 3 });
            }
        }
    }

    componentWillUnmount() {
        // 组件卸载前清除定时器
        if (this.timerId) {
            clearTimeout(this.timerId);
        }
    }

    handleClick() {
        this.setState({ showControl:3});
    } 


    handTypeClick(){
        this.setState({ showControl:4});
    }

    handSelectQuestionClick(){
        this.setState({ showControl:5});
    }


    handQuestionClick(){
        // this.setState({ backColor: "#FFFFFF"});
        this.setState({ showControl:6});

        // Immediately mark first register date to prevent triggerDailyLogin from firing
        let initUser = localStorage.getItem("initUser");
        if (initUser) {
            const alreadyGiven = localStorage.getItem("firstRegisterGiven");
            if (!alreadyGiven) {
                localStorage.setItem("firstRegisterDate", new Date().toDateString());
            }
        }

        // First registration reward (after completing Q&A flow)
        this.triggerFirstRegister();
    }

    // Show BUNS reward popup (works without backend)
    showBunsReward = (amount, type, detail, newBalance) => {
        this.setState({
            rewardPopup: {
                show: true,
                amount,
                type,
                detail,
                newBalance: newBalance,
            }
        });
    }

    // Daily login reward (skip on first register day)
    async triggerDailyLogin() {
        let initUser = localStorage.getItem("initUser");
        if (!initUser) return;
        try {
            const userJson = JSON.parse(initUser);
            const userId = userJson.user_id;
            if (!userId) return;

            const today = new Date().toDateString();
            const lastLogin = localStorage.getItem("lastDailyLogin");
            if (lastLogin === today) return; // Already claimed today

            // Skip if first registered today
            const firstRegisterDate = localStorage.getItem("firstRegisterDate");
            if (firstRegisterDate === today) return;

            const res = await grantBuns(userId, "daily_login", "", "Daily Login");
            if (res.success && res.data) {
                localStorage.setItem("lastDailyLogin", today);
                this.showBunsReward(res.data.new_balance > 0 ? 5 : 5, "daily_login", "Streak Login Reward", res.data.new_balance);
                return;
            }
        } catch (e) {
            console.warn("Daily login API unavailable, using local mode:", e.message || e);
        }

        // Fallback mode: show reward animation even without backend
        const today = new Date().toDateString();
        const lastLogin = localStorage.getItem("lastDailyLogin");
        if (lastLogin !== today) {
            // Skip on first register day
            const firstRegisterDate = localStorage.getItem("firstRegisterDate");
            if (firstRegisterDate === today) return;

            localStorage.setItem("lastDailyLogin", today);
            let streak = parseInt(localStorage.getItem("loginStreak") || "0");
            const yesterday = new Date(Date.now() - 86400000).toDateString();
            const lastDate = localStorage.getItem("lastLoginDate");
            if (lastDate === yesterday) {
                streak++;
            } else {
                streak = 1;
            }
            localStorage.setItem("loginStreak", streak.toString());
            localStorage.setItem("lastLoginDate", today);

            const streakRewards = [5, 10, 15, 20, 25, 30, 50];
            const reward = streak <= streakRewards.length ? streakRewards[streak - 1] : streakRewards[streakRewards.length - 1];

            const currentBuns = parseInt(localStorage.getItem("bunsBalance") || "0");
            const newBalance = currentBuns + reward;
            localStorage.setItem("bunsBalance", newBalance.toString());

            this.showBunsReward(reward, "daily_login", `Day ${streak} Streak Login`, newBalance);
        }
    }

    // First registration reward
    async triggerFirstRegister() {
        let initUser = localStorage.getItem("initUser");
        if (!initUser) return;
        try {
            const userJson = JSON.parse(initUser);
            const userId = userJson.user_id;
            if (!userId) return;

            const alreadyGiven = localStorage.getItem("firstRegisterGiven");
            if (alreadyGiven) {
                console.log("[BUNS] First registration reward already claimed, skipping");
                return;
            }

            // Mark immediately to prevent triggerDailyLogin from firing
            localStorage.setItem("firstRegisterGiven", "true");
            localStorage.setItem("firstRegisterDate", new Date().toDateString());

            const res = await grantBuns(userId, "first_register", "", "Complete initial registration");
            if (res.success && res.data) {
                // Wait for UI to render before showing popup
                setTimeout(() => {
                    this.showBunsReward(100, "first_register", "First Registration Reward", res.data.new_balance);
                }, 500);
                return;
            }
        } catch (e) {
            console.warn("First registration API unavailable, using local mode:", e.message || e);
        }

        // Fallback mode
        const alreadyGiven = localStorage.getItem("firstRegisterGiven");
        if (!alreadyGiven) {
            // Mark immediately
            localStorage.setItem("firstRegisterGiven", "true");
            localStorage.setItem("firstRegisterDate", new Date().toDateString());
            const currentBuns = parseInt(localStorage.getItem("bunsBalance") || "0");
            const newBalance = currentBuns + 100;
            localStorage.setItem("bunsBalance", newBalance.toString());
            console.log("[BUNS] Fallback: First registration reward 100 BUNS, new balance:", newBalance);
            setTimeout(() => {
                this.showBunsReward(100, "first_register", "First Registration Reward", newBalance);
            }, 500);
        }
    }

    render(){
        return(
            <div className="MainContentV" style={{background: this.state.backColor}}>
                {this.state.showControl === 1 && <LaunchScreen></LaunchScreen>}
                {this.state.showControl === 2 && <WelcomPage onClick={this.handleClick}></WelcomPage>}

                {this.state.showControl === 3 && <SelectType onClick={this.handTypeClick}></SelectType>}
                {this.state.showControl === 4 && <WorkType onClick={this.handSelectQuestionClick} onBackClick={this.handleClick}></WorkType>}

                {this.state.showControl === 5 && <QuestionPage onClick={this.handQuestionClick}></QuestionPage>}

                {this.state.showControl === 6 && <MainContentView onMount={this.triggerDailyLogin.bind(this)}></MainContentView>}

                {/* BUNS 奖励弹窗 */}
                <BunsRewardPopup
                    show={this.state.rewardPopup.show}
                    bunsAmount={this.state.rewardPopup.amount}
                    rewardType={this.state.rewardPopup.type}
                    sourceDetail={this.state.rewardPopup.detail}
                    newBalance={this.state.rewardPopup.newBalance}
                    onClose={() => this.setState({ rewardPopup: { show: false, amount: 0, type: '', detail: '', newBalance: 0 } })}
                />
            </div>
        )
    }
}

export default MainPage